var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.647,
    height: 21,
    viewBox: "0 0 17.647 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-apple",
    "data-name": "Icon awesome-apple",
    d: "M15.035,13.347A4.377,4.377,0,0,1,17.38,9.372a5.037,5.037,0,0,0-3.971-2.091c-1.664-.131-3.483.97-4.149.97-.7,0-2.316-.924-3.582-.924-2.616.042-5.4,2.086-5.4,6.245a11.685,11.685,0,0,0,.675,3.807c.6,1.721,2.766,5.94,5.026,5.87C7.164,23.221,8,22.41,9.536,22.41c1.491,0,2.264.839,3.582.839,2.279-.033,4.238-3.868,4.81-5.593a4.648,4.648,0,0,1-2.893-4.309Zm-2.654-7.7a4.416,4.416,0,0,0,1.125-3.4,4.971,4.971,0,0,0-3.183,1.636,4.485,4.485,0,0,0-1.2,3.371,3.938,3.938,0,0,0,3.258-1.608Z",
    transform: "translate(-0.281 -2.25)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApple);
export default __webpack_public_path__ + "static/media/Icon-Apple.968848f402aea0210e079c5682f3f67e.svg";
export { ForwardRef as ReactComponent };